import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  userMenuButton: {
    borderRadius: 0,
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular

  },
  userAvatar: {
    width: 50,
    height: 50,
    '& svg': {
      fontSize: theme.typography.pxToRem(36)
    }
  },
  menuUserName: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    fontSize: theme.typography.pxToRem(14),
    maxWidth: 200,
    textAlign: 'left'
  },
  userMenuPaper: {
    '& ul': {
      '& li': {
        padding: theme.spacing(0),
        '&:not(:first-child)': {
          borderTop: `1px solid ${theme.palette.colors.border}`
        }
      },
      '& a, & li.signOut': {
        padding: theme.spacing(2),
        width: '100%'
      },
      '& li, & a': {
        width: '100%',
        transition: 'all 0.3s ease-in-out',
        color: theme.palette.text.primary,
        textDecoration: 'none',
        minWidth: 175
      },
      '& a.active': {
        color: theme.palette.secondary.main
      }
    },
    '& .MuiListItem-button:hover': {
      backgroundColor: 'transparent',
      '&, & a': {
        color: theme.palette.secondary.main
      }
    }
  },
  logoutButton: {
    borderRadius: theme.spacing(0),
    border: `none`,
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: 1.43,
    textAlign: 'center',
    padding: theme.spacing(1.15, 7),
    '&:hover': {
      color: theme.palette.secondary.main,
      backgroundColor: 'transparent'
    }
  }
}))
